import { IRegVisualization, IDropdownMenu } from './types'

const YOUTUBE_INFO_TRANSLATION_KEY = 'explore__visualizations--youtube--info'

export const DefaultVisualizations: Array<IRegVisualization> = [
 {
  id: 'AF-totalMentions',
  splitId: '',
  component: 'af-total-mentions',
  layout_analytics: { xl: 50, lg: 50, md: 50, sm: 50 },
  layout_split: { xl: 50, lg: 50, md: 100, sm: 100 },
  properties: {
   title: 'explore__visualizations--total-mentions',
   info: 'explore__visualizations--total-mentions--info',
   youtubeInfo: YOUTUBE_INFO_TRANSLATION_KEY,
   size: 'smallest',
   isPagination: false,
   isCSVExport: true,
  },
 },
 {
  id: 'AF-mentionsPerDayAverage',
  splitId: '',
  component: 'af-mentions-per-day-average',
  layout_analytics: { xl: 50, lg: 50, md: 50, sm: 50 },
  layout_split: { xl: 50, lg: 50, md: 100, sm: 100 },
  properties: {
   title: 'explore__visualizations--mentions-day-average',
   info: 'explore__visualizations--mentions-day-average--info',
   youtubeInfo: YOUTUBE_INFO_TRANSLATION_KEY,
   size: 'smallest',
   isPagination: false,
   isCSVExport: true,
  },
 },
 {
  id: 'AF-latestActivity',
  splitId: '',
  component: 'af-latest-activity',
  layout_analytics: { xl: 50, lg: 50, md: 100, sm: 100 },
  layout_split: { xl: 50, lg: 100, md: 100, sm: 100 },
  properties: {
   title: 'brand-app__media-exposure-applet--title',
   info: 'explore__visualizations--latest-activity--info',
   youtubeInfo: YOUTUBE_INFO_TRANSLATION_KEY,
   size: 'medium',
   isPagination: false,
   isCSVExport: true,
  },
 },
 {
  id: 'AF-wordCloud',
  splitId: '',
  component: 'af-word-cloud',
  layout_analytics: { xl: 50, lg: 50, md: 100, sm: 100 },
  layout_split: { xl: 50, lg: 100, md: 100, sm: 100 },
  properties: {
   title: 'explore__visualizations--top-keywords',
   info: 'explore__visualizations--top-keywords--info',
   youtubeInfo: YOUTUBE_INFO_TRANSLATION_KEY,
   size: 'medium',
   isPagination: false,
   isCSVExport: true,
  },
 },
 {
  id: 'AF-topLocations',
  splitId: '',
  component: 'af-top-locations',
  layout_analytics: { xl: 50, lg: 50, md: 50, sm: 100 },
  layout_split: { xl: 50, lg: 100, md: 100, sm: 100 },
  properties: {
   title: 'Top Locations',
   info: 'explore__visualizations--top-locations--info',
   youtubeInfo: YOUTUBE_INFO_TRANSLATION_KEY,
   size: 'medium long-widget',
   isPagination: true,
   tilePagination: 'locations',
   isCSVExport: true,
   isLocationSelector: true,
  },
 },
 {
  id: 'AF-sentiment',
  splitId: '',
  component: 'af-sentiment',
  layout_analytics: { xl: 50, lg: 50, md: 50, sm: 100 },
  layout_split: { xl: 50, lg: 100, md: 100, sm: 100 },
  properties: {
   title: 'Sentiment',
   info: 'explore__visualizations--sentiment--info',
   youtubeInfo: YOUTUBE_INFO_TRANSLATION_KEY,
   size: 'medium long-widget',
   isPagination: 'hide',
   isCSVExport: true,
  },
 },
]

export const DefaultAnalyticsVisualizations: Array<IRegVisualization> = [
 {
  id: 'AF-totalMentions',
  splitId: '',
  component: 'af-total-mentions',
  layout_analytics: { xl: 33, lg: 33, md: 33, sm: 100 },
  layout_split: { xl: 33, lg: 33, md: 100, sm: 100 },
  properties: {
   title: 'explore__visualizations--total-mentions',
   info: 'explore__visualizations--total-mentions--info',
   youtubeInfo: YOUTUBE_INFO_TRANSLATION_KEY,
   size: 'smallest',
   isPagination: false,
   isCSVExport: true,
  },
 },
 {
  id: 'AF-mentionsPerDayAverage',
  splitId: '',
  component: 'af-mentions-per-day-average',
  layout_analytics: { xl: 33, lg: 33, md: 33, sm: 100 },
  layout_split: { xl: 33, lg: 33, md: 100, sm: 100 },
  properties: {
   title: 'explore__visualizations--mentions-day-average',
   info: 'explore__visualizations--mentions-day-average--info',
   youtubeInfo: YOUTUBE_INFO_TRANSLATION_KEY,
   size: 'smallest',
   isPagination: false,
   isCSVExport: true,
  },
 },
 {
  id: 'AF-totalEngagement',
  splitId: '',
  component: 'af-total-engagement',
  layout_analytics: { xl: 33, lg: 33, md: 33, sm: 100 },
  layout_split: { xl: 33, lg: 33, md: 100, sm: 100 },
  properties: {
   title: 'explore__analytics--total_engagement--title',
   info: 'explore__analytics--total_engagement--infotip',
   size: 'smallest',
   isPagination: false,
   isCSVExport: true,
  },
 },
 {
  id: 'AF-latestActivityBySource',
  splitId: '',
  component: 'af-latest-activity-by-source',
  layout_analytics: { xl: 100, lg: 100, md: 100, sm: 100 },
  layout_split: { xl: 100, lg: 100, md: 10100, sm: 100 },
  properties: {
   title: 'brand-app__volume-over-time-by-channel-applet--title',
   info: 'explore__visualizations--latest-activity-by-source--info',
   youtubeInfo: YOUTUBE_INFO_TRANSLATION_KEY,
   size: 'large',
   isPagination: false,
   isCSVExport: true,
  },
 },
 {
  id: 'AF-mostEngagedContent',
  splitId: '',
  component: 'af-most-engaged-content',
  layout_analytics: { xl: 100, lg: 100, md: 100, sm: 100 },
  layout_split: { xl: 100, lg: 100, md: 100, sm: 100 },
  properties: {
   title: 'explore__analytics--most_engaged_content--title',
   info: 'explore__analytics--most_engaged_content--infotip',
   size: 'automatic',
   isPagination: true,
   tilePagination: 'explore__analytics--most_engaged_content--tilePagination',
   isCSVExport: true,
  },
 },
 {
  id: 'AF-engagementTrendBySource',
  splitId: '',
  component: 'af-engagement-trend-by-source',
  layout_analytics: { xl: 100, lg: 100, md: 100, sm: 100 },
  layout_split: { xl: 100, lg: 100, md: 10100, sm: 100 },
  properties: {
   title: 'Engagement Trend by Source Type',
   info: 'Breakdown of engagement across news, social media, and other source types over time',
   size: 'large',
   isPagination: false,
   isCSVExport: true,
  },
 },
 {
  id: 'AF-topLocations',
  splitId: '',
  component: 'af-top-locations',
  layout_analytics: { xl: 33, lg: 50, md: 100, sm: 100 },
  layout_split: { xl: 33, lg: 50, md: 100, sm: 100 },
  properties: {
   title: 'Top Locations',
   info: 'explore__visualizations--top-locations--info',
   size: 'medium long-widget',
   isPagination: true,
   tilePagination: 'explore__analytics--top_locations--tilePagination',
   isCSVExport: true,
   isLocationSelector: true,
  },
 },
 {
  id: 'AF-topEditorialSources',
  splitId: '',
  component: 'af-top-editorial-sources',
  layout_analytics: { xl: 33, lg: 50, md: 100, sm: 100 },
  layout_split: { xl: 33, lg: 50, md: 100, sm: 100 },
  properties: {
   title: 'explore__analytics--top_editorial_sources--title',
   info: 'explore__analytics--top_editorial_sources--infotip',
   size: 'medium long-widget',
   isPagination: true,
   tilePagination: 'explore__analytics--top_editorial_sources--tilePagination',
   isCSVExport: true,
  },
 },
 {
  id: 'AF-topSharedUrls',
  splitId: '',
  component: 'af-top-shared-link',
  layout_analytics: { xl: 33, lg: 50, md: 100, sm: 100 },
  layout_split: { xl: 33, lg: 50, md: 100, sm: 100 },
  properties: {
   title: 'explore__analytics--top_shared_links--title',
   info: 'explore__analytics--top_shared_links--infotip',
   size: 'medium long-widget',
   isPagination: true,
   tilePagination: 'explore__analytics--top_shared_links--tilePagination',
   isCSVExport: true,
  },
 },
 {
  id: 'AF-topBlogs',
  splitId: 'EXPLORE_VISUALIZATION_TOP_BLOGS',
  component: 'af-top-blogs',
  layout_analytics: { xl: 33, lg: 50, md: 100, sm: 100 },
  layout_split: { xl: 33, lg: 50, md: 100, sm: 100 },
  properties: {
   title: 'explore__visualizations--top-blogs',
   info: 'explore__visualizations--top-blogs--info',
   size: 'medium long-widget',
   isPagination: true,
   tilePagination: 'explore__analytics--top_blogs--tilePagination',
   isCSVExport: true,
  },
 },
 {
  id: 'AF-topSubreddits',
  splitId: 'EXPLORE_VISUALIZATION_TOP_SUBREDDITS',
  component: 'af-top-subreddits',
  layout_analytics: { xl: 33, lg: 50, md: 100, sm: 100 },
  layout_split: { xl: 33, lg: 50, md: 100, sm: 100 },
  properties: {
   title: 'explore__visualizations--top-subreddits',
   info: 'explore__visualizations--top-subreddits--info',
   size: 'medium long-widget',
   isPagination: true,
   tilePagination: 'explore__analytics--top_subreddits--tilePagination',
   isCSVExport: true,
  },
 },
 {
  id: 'AF-topForums',
  splitId: 'EXPLORE_VISUALIZATION_TOP_FORUMS',
  component: 'af-top-forums',
  layout_analytics: { xl: 33, lg: 50, md: 100, sm: 100 },
  layout_split: { xl: 33, lg: 50, md: 100, sm: 100 },
  properties: {
   title: 'explore__visualizations--top-forums',
   // info: 'explore__visualizations--top-forums--info',
   size: 'medium long-widget',
   isPagination: true,
   tilePagination: 'explore__analytics--top_forums--tilePagination',
   isCSVExport: true,
  },
 },
]

export const DefaultTwitterVisualizationsAll: Array<IRegVisualization> = [
 {
  id: 'AF-twitterMetrics',
  splitId: '',
  component: 'af-twitter-metrics',
  layout_analytics: { xl: 100, lg: 100, md: 100, sm: 100 },
  layout_split: { xl: 100, lg: 100, md: 100, sm: 100 },
  properties: {
   title: 'explore__visualizations--key-metrics-for-twitter',
   info: 'explore__visualizations--key-metrics-for-twitter--info',
   size: 'medium double-widget',
   isPagination: false,
   isCSVExport: true,
   subWidgets: ['af-metrics-chart', 'af-twitter-metrics-spline'],
  },
 },
 {
  id: 'AF-latestActivityByMentionType',
  splitId: '',
  component: 'af-latest-activity-by-mention-type',
  layout_analytics: { xl: 100, lg: 100, md: 100, sm: 100 },
  layout_split: { xl: 100, lg: 100, md: 100, sm: 100 },
  properties: {
   title: 'explore__visualizations--tweet-type-breakdown',
   info: 'explore__visualizations--tweet-type-breakdown--info',
   size: 'medium double-widget',
   isPagination: false,
   isCSVExport: true,
   subWidgets: [
    'af-latest-activity-by-mention-type-donut',
    'af-latest-activity-by-mention-type-spline',
   ],
  },
 },
 {
  id: 'AF-sentimentTrend',
  splitId: '',
  component: 'af-sentiment-trend',
  layout_analytics: { xl: 100, lg: 100, md: 100, sm: 100 },
  layout_split: { xl: 100, lg: 100, md: 100, sm: 100 },
  properties: {
   title: 'explore__visualizations--sentiment-breakdown-for-twitter',
   info: 'explore__visualizations--sentiment-breakdown-for-twitter--info',
   size: 'medium double-widget',
   isPagination: false,
   isCSVExport: true,
   subWidgets: ['af-sentiment-trend-donut', 'af-sentiment-trend-spline'],
  },
 },
 {
  id: 'AF-wordCloud',
  splitId: '',
  component: 'af-word-cloud',
  layout_analytics: { xl: 100, lg: 100, md: 100, sm: 100 },
  layout_split: { xl: 100, lg: 100, md: 100, sm: 100 },
  properties: {
   title: 'explore__visualizations--top-keywords',
   info: 'explore__visualizations--top-keywords--info',
   size: 'medium',
   isPagination: false,
   isCSVExport: true,
  },
 },
 {
  id: 'AF-positiveWordCloud',
  splitId: '',
  component: 'af-positive-word-cloud',
  layout_analytics: { xl: 50, lg: 50, md: 100, sm: 100 },
  layout_split: { xl: 50, lg: 50, md: 100, sm: 100 },
  properties: {
   title: 'explore__visualizations--top-positive-keywords',
   info: 'explore__visualizations--top-positive-keywords',
   size: 'medium',
   isPagination: false,
   isCSVExport: true,
  },
 },
 {
  id: 'AF-negativeWordCloud',
  splitId: '',
  component: 'af-negative-word-cloud',
  layout_analytics: { xl: 50, lg: 50, md: 100, sm: 100 },
  layout_split: { xl: 50, lg: 50, md: 100, sm: 100 },
  properties: {
   title: 'explore__visualizations--top-negative-keywords',
   info: 'explore__visualizations--top-negative-keywords--info',
   size: 'medium',
   isPagination: false,
   isCSVExport: true,
  },
 },
 {
  id: 'AF-topEmojis',
  splitId: '',
  component: 'af-top-emojis',
  layout_analytics: { xl: 50, lg: 50, md: 100, sm: 100 },
  layout_split: { xl: 50, lg: 50, md: 100, sm: 100 },
  properties: {
   title: 'explore__visualizations--top-emojis',
   info: 'explore__visualizations--top-emojis--info',
   size: 'medium',
   isPagination: false,
   isCSVExport: true,
  },
 },
 {
  id: 'AF-twitterAuthorAuthority',
  splitId: '',
  component: 'af-twitter-author-authority',
  layout_analytics: { xl: 50, lg: 50, md: 50, sm: 100 },
  layout_split: { xl: 50, lg: 50, md: 100, sm: 100 },
  properties: {
   title: 'explore__visualizations--authors-by-authority-level',
   info: 'explore__visualizations--authors-by-authority-level--info',
   size: 'medium',
   isPagination: false,
   isCSVExport: true,
  },
 },

 {
  id: 'AF-mostRetweeted',
  splitId: 'EXPLORE_MOST_RETWEETED',
  component: 'af-twitter-most-retweeted',
  layout_analytics: { xl: 100, lg: 100, md: 100, sm: 100 },
  layout_split: { xl: 100, lg: 100, md: 100, sm: 100 },
  properties: {
   title: 'explore__visualizations--most-retweeted',
   info: 'explore__visualizations--most-retweeted--info',
   size: 'automatic',
   isPagination: true,
   isCSVExport: true,
  },
 },
 {
  id: 'AF-topHashtags',
  splitId: '',
  component: 'af-top-hashtags',
  layout_analytics: { xl: 50, lg: 50, md: 100, sm: 100 },
  layout_split: { xl: 50, lg: 50, md: 100, sm: 100 },
  properties: {
   title: 'explore__visualizations--top-hashtags',
   info: 'explore__visualizations--top-hashtags-influencer--info',
   size: 'medium long-widget',
   isPagination: true,
   isCSVExport: true,
  },
 },
 {
  id: 'AF-topTwitterAuthors',
  splitId: '',
  component: 'af-top-twitter-authors',
  layout_analytics: { xl: 50, lg: 50, md: 100, sm: 100 },
  layout_split: { xl: 50, lg: 50, md: 100, sm: 100 },
  properties: {
   title: 'explore__visualizations--top-twitter-authors',
   info: 'explore__visualizations--top-twitter-authors-influencer--info',
   size: 'medium long-widget',
   isPagination: true,
   isCSVExport: true,
  },
 },
 {
  id: 'AF-topLocations',
  splitId: '',
  component: 'af-top-locations',
  layout_analytics: { xl: 50, lg: 50, md: 100, sm: 100 },
  layout_split: { xl: 50, lg: 50, md: 100, sm: 100 },
  properties: {
   title: 'Top Locations',
   info: 'explore__visualizations--top-locations--info',
   size: 'medium long-widget',
   isPagination: true,
   tilePagination: 'locations',
   isCSVExport: true,
   isLocationSelector: true,
  },
 },
 {
  id: 'AF-gender',
  splitId: '',
  component: 'af-gender-stacked',
  layout_analytics: { xl: 50, lg: 50, md: 100, sm: 100 },
  layout_split: { xl: 50, lg: 50, md: 100, sm: 100 },
  properties: {
   title: 'explore__visualizations--gender',
   info: 'explore__visualizations--gender--info',
   size: 'medium',
   isPagination: false,
   isCSVExport: true,
  },
 },
]

export const DefaultCompareVisualizations: Array<IRegVisualization> = [
 {
  id: 'AF-compareLatestActivity',
  splitId: '',
  component: 'af-compare-latest-activity',
  layout_analytics: { xl: 100, lg: 100, md: 100, sm: 100 },
  layout_split: { xl: 100, lg: 100, md: 100, sm: 100 },
  properties: {
   title: 'brand-app__media-exposure-applet--title',
   info: 'explore__visualizations--latest-activity-by-search--info',
   size: 'medium__tall',
   isPagination: false,
   isCSVExport: true,
  },
 },
 {
  id: 'AF-compareSovByMentions',
  splitId: '',
  component: 'af-compare-sov-by-mention-type',
  layout_analytics: { xl: 100, lg: 100, md: 100, sm: 100 },
  layout_split: { xl: 100, lg: 100, md: 100, sm: 100 },
  properties: {
   title: 'explore__visualizations--sov-by-mentions',
   info: 'explore__visualizations--sov-by-mentions--info',
   size: 'medium double-widget',
   isPagination: false,
   isCSVExport: true,
   subWidgets: ['af-compare-sov-by-mention-type-donut', 'af-compare-sov-by-mention-type-vert'],
  },
 },
 {
  id: 'AF-compareSovByImpressions',
  splitId: '',
  component: 'af-compare-sov-by-impressions',
  layout_analytics: { xl: 100, lg: 100, md: 100, sm: 100 },
  layout_split: { xl: 100, lg: 100, md: 100, sm: 100 },
  properties: {
   title: 'explore__visualizations--sov-by-tweet-impressions',
   info: 'explore__visualizations--sov-by-tweet-impressions--info',
   size: 'medium double-widget',
   isPagination: false,
   isCSVExport: true,
   subWidgets: ['af-compare-sov-by-impressions-donut', 'af-compare-sov-by-impressions-spline'],
  },
 },
 {
  id: 'AF-compareSovBySources',
  splitId: '',
  component: 'af-compare-sov-by-source',
  layout_analytics: { xl: 100, lg: 100, md: 100, sm: 100 },
  layout_split: { xl: 100, lg: 100, md: 100, sm: 100 },
  properties: {
   title: 'explore__visualizations--sov-by-source',
   info: 'explore__visualizations--sov-by-source--info',
   size: 'medium__tall',
   isPagination: false,
   isCSVExport: true,
  },
 },
 {
  id: 'AF-compareSovByLocation',
  splitId: '',
  component: 'af-compare-sov-by-location',
  layout_analytics: { xl: 100, lg: 100, md: 100, sm: 100 },
  layout_split: { xl: 100, lg: 100, md: 100, sm: 100 },
  properties: {
   title: 'explore__visualizations--sov-by-location',
   info: 'explore__visualizations--sov-by-location--info',
   size: 'medium__tall sov',
   isPagination: false,
   isCSVExport: true,
  },
 },
 {
  id: 'AF-compareSentiment',
  splitId: '',
  component: 'af-compare-sentiment',
  layout_analytics: { xl: 100, lg: 100, md: 100, sm: 100 },
  layout_split: { xl: 100, lg: 100, md: 100, sm: 100 },
  properties: {
   title: 'Sentiment',
   info: 'explore__visualizations--sentiment--info',
   size: 'medium__tall',
   isPagination: false,
   isCSVExport: true,
  },
 },
 {
  id: 'AF-compareWordCloud',
  splitId: '',
  component: 'af-compare-word-cloud',
  layout_analytics: { xl: 100, lg: 100, md: 100, sm: 100 },
  layout_split: { xl: 100, lg: 100, md: 100, sm: 100 },
  properties: {
   title: 'explore__visualizations--top-keywords',
   info: 'explore__visualizations--top-keywords--info',
   size: 'automatic',
   isPagination: false,
   isCSVExport: true,
   hideToolbar: true,
  },
 },
 // {
 //     id: 'AF-compareTopContent',
 //     component: 'af-compare-top-content',
 //     layout_analytics: { xl: 100, lg: 100, md: 100, sm: 100 },
 //     layout_split: { xl: 100, lg: 100, md: 100, sm: 100 },
 //     properties: {
 //         title: 'Top Content',
 //         size: 'automatic',
 //         isPagination: false,
 //         isCSVExport: true,
 //     },
 // },
]

export const ResizeInterval = 500

export function prettyNames(key: string) {
 let name = ''

 switch (key) {
  case 'all':
   name = 'All'
   break
  case 'Message Boards':
   name = 'Forums'
   break
  case 're':
   name = 'Reddit'
   break
  default:
   name = key
   break
 }

 return name
}

export function getSourceTypes(key: string) {
 let name = ''

 switch (key) {
  case 'All':
   name = 'all'
   break
  case 'Forums':
   name = 'Message Boards'
   break
  case 'Reddit':
   name = 're'
   break
  default:
   name = key
   break
 }

 return name
}

export function getFlexData(view: string, size: string, layoutData: IRegVisualization) {
 return layoutData['layout_' + view][size]
}

export const CSVMenuItem: IDropdownMenu = {
 name: 'Download CSV',
 icon: 'ic_get_app_24px',
 click: 'exportCSV',
 translationKey: 'wc-reporting-header__exports--download-csv',
}
